import * as React from 'react';
import type { EmployeeSearchResult } from '../../Search/Employee/EmployeeSearchResult.csharp';
import type { SearchResultResponse } from '../../Search/SearchResultResponse.csharp';
import { EmployeeCard } from '~/Partials/EmployeeCard/EmployeeCard';
import { CollapseFilters } from '~/Partials/Filters/CollapseFilters';
import { FacetsAccordionList } from '~/Partials/Filters/Facets/FacetsAccordionList';
import { PagedFetchData } from '~/Partials/PagedFetchData/PagedFetchData';
import { useSearchBase } from '~/Partials/SearchBase/useSearchBase';
import { SearchBox } from '~/Partials/SearchBox/SearchBox';
import { SelectedFiltersList } from '~/Partials/SelectedFiltersList/SelectedFiltersList';
import styles from './EmployeeListSearch.module.css';
import type { EmployeeListSearchViewModel } from './EmployeeListSearchViewModel.csharp';

export const EmployeeListSearch: React.FC<EmployeeListSearchViewModel> = props => {
    const { facets, translations, searchUrl, phrase, selectedFacets: initialSelectedFacets } = props;

    const { searchParams, handleQueryChange, handleFacetChange, getBaseSearchQueryParameters } = useSearchBase({
        phrase: phrase || '',
        facets,
        selectedFacets: initialSelectedFacets || [],
    });

    const { selectedFacets } = searchParams;

    return (
        <div>
            <SearchBox
                value={searchParams.phrase}
                placeholder={translations.searchForEmployees}
                onChange={event => handleQueryChange(event.target.value)}
            />
            <div className={styles.Filters}>
                <CollapseFilters
                    translations={translations}
                    filters={
                        <FacetsAccordionList
                            facets={facets}
                            selectedFacets={selectedFacets}
                            handleFacetChange={handleFacetChange}
                        />
                    }
                    shouldDisplayFilters={() => facets.some(value => value.options.length > 0)}
                />
            </div>
            <div className={styles.Body}>
                <SelectedFiltersList
                    facets={facets}
                    selectedFacets={selectedFacets}
                    removeFilterDescription={translations.removeFilter}
                    onRemoveFacet={handleFacetChange}
                />
                <div className={styles.Results}>
                    <h2 className="visuallyHidden">{translations.results}</h2>
                    <PagedFetchData<SearchResultResponse<EmployeeSearchResult>, EmployeeSearchResult>
                        baseUrl={searchUrl}
                        searchParams={getBaseSearchQueryParameters(searchParams)}
                        debounceTime={200}
                        take={24}
                        translations={{ ...translations }}
                    >
                        {({ data }) => <EmployeeCard {...data} key={data.firstName + data.lastName} />}
                    </PagedFetchData>
                </div>
            </div>
        </div>
    );
};
